import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import ChevronSVG from '../../../../../../images/svg/icons8-expand-arrow';
import { Popover } from '../../../../../global/popover/popover';
import './_operator-shared-screen-dropdown.scss';

type OperatorSharedScreenValue = boolean | null;

interface IProps {
    value: OperatorSharedScreenValue;
    onChange: (value: OperatorSharedScreenValue) => void;
}

const OPTIONS: { value: OperatorSharedScreenValue; id: string; defaultMessage: string }[] = [
    { value: null, id: 'oe.control.operatorSharedScreen.unspecified', defaultMessage: 'Not Specified' },
    { value: true, id: 'oe.control.operatorSharedScreen.yes', defaultMessage: 'Yes' },
    { value: false, id: 'oe.control.operatorSharedScreen.no', defaultMessage: 'No' },
];

const OperatorSharedScreenDropdown = ({ value, onChange }: IProps) => {
    const triggerRef = useRef<HTMLDivElement>(null);
    const [isOpen, setIsOpen] = useState(false);

    const currentOption = OPTIONS.find(o => o.value === value) ?? OPTIONS[0];

    const handleSelect = (selected: OperatorSharedScreenValue) => {
        onChange(selected);
        setIsOpen(false);
    };

    return (
        <div
            className={classnames('operator-shared-screen-dropdown', {
                'operator-shared-screen-dropdown--active': isOpen,
            })}
            ref={triggerRef}
            onClick={() => setIsOpen(prev => !prev)}
        >
            <span className='operator-shared-screen-dropdown__label'>
                <FormattedMessage
                    id='oe.control.operatorSharedScreen.label'
                    defaultMessage='Operator Shared Screen'
                    description='Operator shared screen field label'
                />
            </span>
            <div className='operator-shared-screen-dropdown__trigger'>
                <span className={classnames('operator-shared-screen-dropdown__value', {
                    'operator-shared-screen-dropdown__value--selected': value !== null,
                })}>
                    <FormattedMessage
                        id={currentOption.id}
                        defaultMessage={currentOption.defaultMessage}
                    />
                </span>
                <ChevronSVG />
            </div>
            <Popover
                padding={0}
                isOpen={isOpen}
                buttonRef={triggerRef}
                onClickOutside={() => setIsOpen(false)}
                customWidth={120}
            >
                <div className='operator-shared-screen-dropdown__options'>
                    {OPTIONS.map(option => (
                        <div
                            key={String(option.value)}
                            className={classnames('operator-shared-screen-dropdown__option', {
                                'operator-shared-screen-dropdown__option--selected': option.value === value,
                                'operator-shared-screen-dropdown__option--unspecified': option.value === null,
                            })}
                            onClick={e => {
                                e.stopPropagation();
                                handleSelect(option.value);
                            }}
                        >
                            <FormattedMessage
                                id={option.id}
                                defaultMessage={option.defaultMessage}
                            />
                        </div>
                    ))}
                </div>
            </Popover>
        </div>
    );
};

export { OperatorSharedScreenDropdown };
